import { Injectable } from '@angular/core';
import { ContextService, XenaClient } from 'src/app/services';
import {  BaseService } from 'src/app/xena-api/controllers/base';
import { IXenaApp  } from 'src/app/xena-api/dtos';
import { IListOptionsFilter  } from 'src/app/xena-api/filters';

@Injectable({
  providedIn: 'root'
})
export class XenaAppService extends BaseService<IXenaApp, IListOptionsFilter> {
  constructor(xenaClient: XenaClient, context: ContextService) {
    super(xenaClient, context, 'XenaApp');
  }
}
